import Button from '@mui/material/Button';
import { hexWithOpacity } from 'common/utils';
import { colors } from 'styles/colors';
import useStyles from './styles';
import Circle from 'components/common/Circle/Circle';
import CustomText from 'components/common/CustomText/CustomText';

interface Props {
  publishedAt: string | null;
}

export default function PublishStatus({ publishedAt }: Props) {
  const styles = useStyles();

  const color = publishedAt ? colors.success : colors.pending;
  const label = publishedAt ? 'Published' : 'Unpublished';

  return (
    <div>
      <Button
        className={styles.statusOuterButton}
        sx={{
          paddingLeft: 0,
          backgroundColor: hexWithOpacity(color, 0.1),
          color: color,
          '&&:hover': {
            bgcolor: hexWithOpacity(color, 0.3),
            color: color,
          },
        }}
      >
        <Circle
          boxSize={20}
          circleSize={6}
          color={color}
        />
        <CustomText text={label} color={color} fontSize={14} />
      </Button>
    </div>
  );
}
